var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQ2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.0000610352,
    width: 40.4743,
    height: 40,
    rx: 5,
    fill: "rgba(254, 119, 1, 1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_4428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5426 19.4171H17.0684M18.6969 14.72V13.1428M21.3369 14.72V13.1428M18.6969 26.8571V24.9714M21.3369 26.8571V24.9714M21.5084 19.4171C21.8197 19.4216 22.1287 19.3642 22.4177 19.2483C22.7066 19.1323 22.9695 18.96 23.1913 18.7415C23.413 18.5229 23.5891 18.2625 23.7092 17.9753C23.8294 17.6881 23.8913 17.3798 23.8912 17.0685C23.8912 16.4456 23.6438 15.8483 23.2033 15.4078C22.7629 14.9674 22.1655 14.72 21.5426 14.72H17.9255C17.6982 14.72 17.4802 14.8103 17.3194 14.971C17.1587 15.1317 17.0684 15.3498 17.0684 15.5771V24.1485C17.0684 24.3758 17.1587 24.5939 17.3194 24.7546C17.4802 24.9154 17.6982 25.0057 17.9255 25.0057H21.5084C22.2449 25.0057 22.9513 24.7131 23.4721 24.1923C23.9929 23.6714 24.2855 22.9651 24.2855 22.2285C24.2855 21.492 23.9929 20.7856 23.4721 20.2648C22.9513 19.744 22.2449 19.4514 21.5084 19.4514V19.4171Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 31.1428C26.1538 31.1428 31.1426 26.154 31.1426 19.9999C31.1426 13.8459 26.1538 8.85709 19.9998 8.85709C13.8458 8.85709 8.85693 13.8459 8.85693 19.9999C8.85693 26.154 13.8458 31.1428 19.9998 31.1428Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_4428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 7.99994)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ2);
export default __webpack_public_path__ + "static/media/q2.aecbad2e6b3d87276c4dd56b989b90de.svg";
export { ForwardRef as ReactComponent };